/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BasicTeacherCreate } from '../model/basicTeacherCreate';
import { BasicTeacherReportData } from '../model/basicTeacherReportData';
import { QuestionnaireReportData } from '../model/questionnaireReportData';
import { TeacherComparisonCreate } from '../model/teacherComparisonCreate';
import { TeacherComparisonData } from '../model/teacherComparisonData';
import { TeacherMultiReportCreate } from '../model/teacherMultiReportCreate';
import { TeacherMultiReportData } from '../model/teacherMultiReportData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TeacherReportsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getTeacherBasicReport
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherBasicReport(body: BasicTeacherCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getTeacherBasicReport(body: BasicTeacherCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getTeacherBasicReport(body: BasicTeacherCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getTeacherBasicReport(body: BasicTeacherCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherBasicReport.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request('post',`${this.basePath}/api/v1/teacher-reports/basic/`,
            {
                body: body,
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherBasicReportData
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherBasicReportData(body: BasicTeacherCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<BasicTeacherReportData>;
    public getTeacherBasicReportData(body: BasicTeacherCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BasicTeacherReportData>>;
    public getTeacherBasicReportData(body: BasicTeacherCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BasicTeacherReportData>>;
    public getTeacherBasicReportData(body: BasicTeacherCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherBasicReportData.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BasicTeacherReportData>('post',`${this.basePath}/api/v1/teacher-reports/basic-data/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherComparisionReport
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherComparisionReport(body: TeacherComparisonCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getTeacherComparisionReport(body: TeacherComparisonCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getTeacherComparisionReport(body: TeacherComparisonCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getTeacherComparisionReport(body: TeacherComparisonCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherComparisionReport.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request('post',`${this.basePath}/api/v1/teacher-reports/comparison/`,
            {
                body: body,
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherComparisionReportData
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherComparisionReportData(body: TeacherComparisonCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherComparisonData>;
    public getTeacherComparisionReportData(body: TeacherComparisonCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherComparisonData>>;
    public getTeacherComparisionReportData(body: TeacherComparisonCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherComparisonData>>;
    public getTeacherComparisionReportData(body: TeacherComparisonCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherComparisionReportData.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherComparisonData>('post',`${this.basePath}/api/v1/teacher-reports/comparison-data/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherMultiReport
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherMultiReport(body: TeacherMultiReportCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getTeacherMultiReport(body: TeacherMultiReportCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getTeacherMultiReport(body: TeacherMultiReportCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getTeacherMultiReport(body: TeacherMultiReportCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherMultiReport.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request('post',`${this.basePath}/api/v1/teacher-reports/multireport/`,
            {
                body: body,
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherMultiReportData
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherMultiReportData(body: TeacherMultiReportCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherMultiReportData>;
    public getTeacherMultiReportData(body: TeacherMultiReportCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherMultiReportData>>;
    public getTeacherMultiReportData(body: TeacherMultiReportCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherMultiReportData>>;
    public getTeacherMultiReportData(body: TeacherMultiReportCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherMultiReportData.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherMultiReportData>('post',`${this.basePath}/api/v1/teacher-reports/multireport-data/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherQuestionnaireReport
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherQuestionnaireReport(body: BasicTeacherCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getTeacherQuestionnaireReport(body: BasicTeacherCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getTeacherQuestionnaireReport(body: BasicTeacherCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getTeacherQuestionnaireReport(body: BasicTeacherCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherQuestionnaireReport.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request('post',`${this.basePath}/api/v1/teacher-reports/questionnaire/`,
            {
                body: body,
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTeacherQuestionnaireReportData
     * Generate teacher report
     * @param body 
     * @param format 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeacherQuestionnaireReportData(body: BasicTeacherCreate, format?: string, observe?: 'body', reportProgress?: boolean): Observable<QuestionnaireReportData>;
    public getTeacherQuestionnaireReportData(body: BasicTeacherCreate, format?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QuestionnaireReportData>>;
    public getTeacherQuestionnaireReportData(body: BasicTeacherCreate, format?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QuestionnaireReportData>>;
    public getTeacherQuestionnaireReportData(body: BasicTeacherCreate, format?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTeacherQuestionnaireReportData.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (format !== undefined && format !== null) {
            queryParameters = queryParameters.set('format', <any>format);
        }

        let headers = this.defaultHeaders;

        // authentication (ISophiAuthentication) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/pdf'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<QuestionnaireReportData>('post',`${this.basePath}/api/v1/teacher-reports/questionnaire-data/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
